import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React__default from 'react';
import { Classes } from '@blueprintjs/core';
import cx from 'classnames';
import { Slot } from '@radix-ui/react-slot';

var _excluded = ["className", "elevation", "interactive", "asChild"];
var Card = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      elevation = _ref.elevation,
      interactive = _ref.interactive,
      _ref$asChild = _ref.asChild,
      asChild = _ref$asChild === void 0 ? false : _ref$asChild,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = cx(Classes.CARD, _defineProperty({}, Classes.INTERACTIVE, interactive), Classes.elevationClass(elevation), className);

  if (asChild) {
    /*#__PURE__*/
    React__default.createElement(Slot, _extends({
      className: classes
    }, props, {
      ref: ref
    }));
  }

  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, props, {
    ref: ref
  }));
});

export { Card };
//# sourceMappingURL=card.js.map
